import LatestBill from 'modules/MyBills/components/LatestBill/LatestBill';

export default LatestBill;
